/**
 * Format a duration in seconds as `hh:mm:ss`, or `<d>d hh:mm:ss` from 24 hours on
 * (113098 gives `1d 07:24:58`). Empty, invalid or non-positive values give `00:00:00`.
 */
export const formatDuration = (seconds: number | null | undefined): string => {
	if (!seconds || !Number.isFinite(seconds) || seconds <= 0) return "00:00:00";

	const total = Math.floor(seconds);
	const days = Math.floor(total / 86400);
	const hh = String(Math.floor((total % 86400) / 3600)).padStart(2, "0");
	const mm = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
	const ss = String(total % 60).padStart(2, "0");

	const time = `${hh}:${mm}:${ss}`;
	return days > 0 ? `${days}d ${time}` : time;
};
